import { DEFAULT_COUNTRY, toE164, type CountryCode } from './phone';

/**
 * Customer details shared by the kiosk (v3) and the client app. The v1 kiosk reducer that lived
 * here was removed with v1 (owner 02.11.2026); the kiosk's flow is in v2/kiosk/flow.ts.
 */
export interface CustomerDraft {
  fullName: string;
  /** Country of the mobile number (picker, default Portugal). */
  phoneCountry: CountryCode;
  /** National digits only; the E.164 form is computed with `toE164`. */
  phone: string;
  email: string;
  privacy: boolean;
  marketing: boolean;
}

export const emptyCustomer: CustomerDraft = {
  fullName: '',
  phoneCountry: DEFAULT_COUNTRY,
  phone: '',
  email: '',
  privacy: false,
  marketing: false,
};

export type CustomerField = 'fullName' | 'phone' | 'email' | 'privacy';

/** Same rules as the API (domain schema), checked early for instant feedback. */
export function customerErrors(c: CustomerDraft): CustomerField[] {
  const errs: CustomerField[] = [];
  if (c.fullName.trim().length < 2) errs.push('fullName');
  if (!toE164(c.phoneCountry, c.phone)) errs.push('phone');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email.trim())) errs.push('email');
  if (!c.privacy) errs.push('privacy');
  return errs;
}

/** Today's date on the kiosk (YYYY-MM-DD, device local time). */
export function kioskToday(now: Date = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}
